import { useAuth } from "react-oidc-context";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { TenantProvider } from "./context/TenantContext";
import { AccessProvider } from "./context/AccessContext";
import { RequireArea } from "./components/RequireArea";
import { UIStateProvider } from "./context/UIStateContext";
import { DashboardFiltersProvider } from "./context/DashboardFiltersContext";
import { Shell } from "./components/Shell";
import { Login } from "./pages/Login";
import { Home } from "./pages/Home";
import { Dashboards } from "./pages/Dashboards";
import { DashboardViewer } from "./pages/DashboardViewer";
import { Reports } from "./pages/Reports";
import { Integrations } from "./pages/Integrations";
import { ReportDetail } from "./pages/ReportDetail";
import { ReportSchedule } from "./pages/ReportSchedule";
import { Users } from "./pages/Users";
import { UserEdit } from "./pages/UserEdit";
import { MyProfile } from "./pages/MyProfile";
import { Permissions } from "./pages/Permissions";
import { Logs } from "./pages/Logs";
import { Settings } from "./pages/Settings";
import { ModeloDeIA } from "./pages/ModeloDeIA";
import { Notifications } from "./pages/Notifications";
import { Modulo } from "./pages/Modulo";
import { Vendedores } from "./pages/Vendedores";

export function App() {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "var(--text-muted)",
      }}>
        Carregando sessão…
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    return <Login />;
  }

  return (
    <TenantProvider>
      <AccessProvider>
      <UIStateProvider>
        <DashboardFiltersProvider>
          <BrowserRouter>
            <Shell>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/callback" element={<Home />} />
            <Route path="/dashboards" element={<RequireArea area="dashboards"><Dashboards /></RequireArea>} />
            <Route path="/dashboards/:id" element={<RequireArea area="dashboards"><DashboardViewer /></RequireArea>} />
            <Route path="/relatorios" element={<RequireArea area="relatorios"><Reports /></RequireArea>} />
            <Route path="/relatorios/agendar" element={<RequireArea area="relatorios.reenviar"><ReportSchedule /></RequireArea>} />
            <Route path="/relatorios/:id" element={<RequireArea area="relatorios"><ReportDetail /></RequireArea>} />
            <Route path="/vendedores" element={<RequireArea area="vendedores"><Vendedores /></RequireArea>} />
            <Route path="/integracoes" element={<RequireArea area="integracoes"><Integrations /></RequireArea>} />
            <Route path="/usuarios" element={<RequireArea area="usuarios"><Users /></RequireArea>} />
            <Route path="/usuarios/:id" element={<RequireArea area="usuarios"><UserEdit /></RequireArea>} />
            <Route path="/perfil" element={<MyProfile />} />
            <Route path="/permissoes" element={<Permissions />} />
            <Route path="/logs" element={<RequireArea area="logs"><Logs /></RequireArea>} />
            <Route path="/config" element={<RequireArea area="configuracoes"><Settings /></RequireArea>} />
            <Route path="/modelo-ia" element={<RequireArea area="configuracoes.llm"><ModeloDeIA /></RequireArea>} />
            <Route path="/notificacoes" element={<RequireArea area="notificacoes"><Notifications /></RequireArea>} />
            {/* Uma tela so para os dois modulos: o que muda e o conteudo, nao
                o desenho. Duas paginas iguais divergiriam na primeira correcao. */}
            <Route path="/modulos/:modulo" element={<RequireArea area="modulos"><Modulo /></RequireArea>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
            </Shell>
          </BrowserRouter>
        </DashboardFiltersProvider>
      </UIStateProvider>
      </AccessProvider>
    </TenantProvider>
  );
}

function NotFound() {
  return (
    <>
      <div className="page-head">
        <h1 className="h1">404 — Página não encontrada</h1>
        <div className="sub">A rota que você tentou não existe.</div>
      </div>
      <div className="card">
        <a href="/" className="btn btn-primary">← Voltar pra home</a>
      </div>
    </>
  );
}
